'use client'

import { Text } from '@components/Helpers'
import VerticalDivider from '@components/VerticalDivider'
import { Grid, styled, useTheme } from '@mui/material'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

function HeaderText({ children }: { children: ReactNode }) {
  const theme = useTheme()
  return (
    <Text
      sx={{
        // The muted grey the rest of the app uses for a caption.
        color: 'var(--dewi_colors_gray_6)',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.9rem',
        },
        [theme.breakpoints.up('sm')]: {
          fontSize: '1rem',
        },
      }}
    >
      {children}
    </Text>
  )
}

function InfoText({ children }: { children: ReactNode }) {
  const theme = useTheme()
  return (
    <Text
      sx={{
        // A stat, so it is set in the display face like the ones on the home page.
        fontFamily: 'var(--font-display), var(--font-nunito), sans-serif',
        fontWeight: 700,
        [theme.breakpoints.down('md')]: {
          fontSize: '0.9rem',
        },
        [theme.breakpoints.up('md')]: {
          fontSize: '1rem',
        },
      }}
    >
      {children}
    </Text>
  )
}

const GridItem = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: 40,
    paddingRight: 40,
  },
}))

type ExploreHeaderProps = {
  supply: number
  legendary: number
  auctioned: number
  owners: number
  burnt: number
}

const ExploreHeader = ({
  supply,
  legendary,
  auctioned,
  owners,
  burnt,
}: ExploreHeaderProps) => {
  const { t } = useTranslation()

  return (
    <Grid
      container
      textAlign="center"
      justifyContent="center"
      alignItems="center"
    >
      <GridItem item>
        <HeaderText>{t('explorerPage.headerTitle.supply')}</HeaderText>
        <InfoText>{supply}</InfoText>
      </GridItem>
      <VerticalDivider />
      <GridItem item>
        <HeaderText>{t('explorerPage.headerTitle.legendary')}</HeaderText>
        <InfoText>{legendary}</InfoText>
      </GridItem>
      <VerticalDivider />
      <GridItem item>
        <HeaderText>{t('explorerPage.headerTitle.auctioned')}</HeaderText>
        <InfoText>{auctioned}</InfoText>
      </GridItem>
      <VerticalDivider />
      <GridItem item>
        <HeaderText>{t('explorerPage.headerTitle.owners')}</HeaderText>
        <InfoText>{owners}</InfoText>
      </GridItem>
      <VerticalDivider />
      <GridItem item>
        <HeaderText>{t('explorerPage.headerTitle.burnt')}</HeaderText>
        <InfoText>{burnt}</InfoText>
      </GridItem>
    </Grid>
  )
}

export default ExploreHeader
